module.exports = __webpack_public_path__ + "png/cards2.png?66ac07ab3e30d63b6ba52d0b295052a9";